import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Path = ({ pathList }) => {
  const navigate = useNavigate();
  const renderPathRow = () => {
    if (pathList && pathList.length) {
      return pathList.map((item, index) => {
        return item.link ? (
          <div
            key={index} // Key for each item for better performance
            className='path_name'
            // to={`/${item.link}/${item.id}`} // Dynamic link based on item.link and item.id
            onClick={() => navigate(`/${item.link}`)}
          >
            / {item.name}
          </div>
        ) : (
          <span key={item.id} className='path_name'>
            / {item.name}
          </span>
        );
      });
    }

    return null; // Return null to avoid rendering an empty element
  };
  return (
    <div className='container mt-4 mb-4'>
      <div className='d-flex gap-1'>
        <div
          className='pb-2'
          onClick={() => {
            navigate('/');
          }}
        >
          <img src='/img/homeicon.png' className='pathicon' />
        </div>
        <div className='d-flex align-items-center flex-wrap'>{renderPathRow()}</div>
      </div>
    </div>
  );
};
